import BaseService from './base/base.service'
import AuthService from './Authentication.service';

export default class UserService extends BaseService {

    // constructor(){
    //     super('user')
    // }

    async register(payload) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/register`, {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                },
                "body": JSON.stringify(payload)
            })

            return await response.json();
        } catch (e) {
            throw e
        }
    }
    
    async login(username, password) {
        const payload = {
            email: username,
            password,
        }
        try {
            const response = await fetch(`${this.BASE_URL}/user/login`, {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                },
                "credentials": "include",
                "body": JSON.stringify(payload)
            })

            return await response.json();
        } catch (e) {
            throw e
        }
    }

    async requestPasswordReset(email) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/recovery/${email}`, {
                "method": "GET",
                "headers": {
                    "Content-Type": "application/json",
                }
            })

            // const data = await response.json()
            return response.json();
        } catch (e) {
            throw e;
        }
    }

    async changePasswordByRecoveryToken(token, password) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/password/reset`, {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${new AuthService().getToken()}`
                },
                "body": JSON.stringify({
                    token,
                    password,
                })
            })

            // const data = await response.json()
            return response.json();
        } catch (e) {
            throw e;
        }
    }
    async changePassword(password, keycloakUserId) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/change`, {
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${new AuthService().getToken()}`
                },
                "body": JSON.stringify({
                    password,
                    keycloakUserId,
                })
            })

            // const data = await response.json()
            return true;
        } catch (e) {
            throw e;
        }
    }


    async activeUserAccount(activationToken) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/active/${activationToken}`, {
                "method": "GET",
                "headers": {
                    "Content-Type": "application/json",
                }
            })

            const json = await response.json();
            return json.result

        } catch (e) {
            throw e
        }
    }


    async verifyUserExists(email) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/verify/${email}`, {
                "method": "GET",
                "headers": {
                    "Content-Type": "application/json",
                }
            })

            const json = await response.json();
            return json.result

        } catch (e) {
            throw e
        }
    }


    async verifyTaxidExists(taxid) {
        try {
            const response = await fetch(`${this.BASE_URL}/user/verify-taxid/${taxid}`, {
                "method": "GET",
                "headers": {
                    "Content-Type": "application/json",
                }
            })

            const json = await response.json();
            return json.result

        } catch (e) {
            throw e
        }
    }

    async sendBankVerification(files, data) {
        const formData = new FormData();
        
        Object.entries(files).forEach(([key, value]) => {
            formData.append(key, value);
        });
        
        formData.append('data', JSON.stringify(data));

        const xhr = new XMLHttpRequest();

        xhr.open('POST', `${this.BASE_URL}/user/request_verification`);

        xhr.setRequestHeader('Authorization', `Bearer ${new AuthService().getToken()}`);
        xhr.setRequestHeader('Cookie', document.cookie);

        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                return response;
            } else {
                console.error('Erro ao enviar o arquivo:', xhr.statusText);
                return null;
            }
        };

        xhr.onerror = () => {
            console.error('Erro no upload:', xhr.statusText);
            return null;
        };

        xhr.send(formData);
    }

    async uploadImage(file, url) {
        const formData = new FormData();
        formData.append("file", file);

        return fetch(`${this.BASE_URL}/${url}`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${new AuthService().getToken()}`,
            },
            body: formData,
        });
    }
}


